// extracted by mini-css-extract-plugin
export default {"container":"gG-z","disabled":"hG-z","bgBlack":"iG-z","content":"jG-z","countdown":"kG-z","topCaption":"lG-z","topHeading":"mG-z","heading":"nG-z","copy":"oG-z"};